import { ActionTitle } from "@/components/actionTitle/ActionTitle";
import { getCoworkerSettingsValue } from "@/features/workspace/customize/settings/CoworkerSettingsControl";
import {
  ScrollContainer,
  WidgetContainer,
} from "@/features/workspace/widgets/Components";
import { ONE_WEEK_START, TWO_WEEKS_END } from "@/utils/dateUtils";
import { type WidgetSetting, type WidgetSize, useTasks } from "@repo/api";
import { Text, Toggle } from "@repo/skapa";
import { t, useTranslation } from "@repo/translation";
import { localizeDateRange } from "@repo/ui";
import { useState } from "react";

import { CARD_HEIGHT_NORMAL, CARD_HEIGHT_TALL } from "../constants";
import { PrecallList } from "./PrecallList";

const getPrecallSettings = (settings?: WidgetSetting) => {
  const unitId =
    typeof settings?.STORE === "string" ? settings.STORE : undefined;

  const { email, teamId } = getCoworkerSettingsValue(
    settings?.COWORKER?.toString() ?? ""
  );

  // Default date range
  const dueDateRange = [ONE_WEEK_START, TWO_WEEKS_END];

  return { unitId, email, teamId, dueDateRange };
};

export const PrecallWidget = ({
  title,
  size,
  settings,
}: {
  title: string;
  size: WidgetSize;
  settings?: WidgetSetting;
}) => {
  const { unitId, email, teamId, dueDateRange } = getPrecallSettings(settings);
  const { dateFnsLocale } = useTranslation();
  const [showCompleted, setShowCompleted] = useState(false);

  const { data } = useTasks({
    subTaskType: "preCallTask",
    fromDate: dueDateRange[0],
    toDate: dueDateRange[1],
    unitId,
    emails: email,
    teamId,
  });

  const list =
    data?.filter((el) =>
      showCompleted ? el.isDone === true : el.isDone === false
    ) ?? [];

  const pendingList = data?.filter((el) => el.isDone === false);

  return (
    <>
      <WidgetContainer
        size={size === "M" ? CARD_HEIGHT_TALL : CARD_HEIGHT_NORMAL}
      >
        <ActionTitle title={`${title} (${pendingList?.length ?? 0})`} />
        <Text>
          {localizeDateRange(dueDateRange[0], dueDateRange[1], dateFnsLocale)}
        </Text>
        <Toggle
          activeIndex={showCompleted ? 1 : 0}
          onClick={(_: any, index: number) => {
            setShowCompleted(index === 1);
          }}
          buttons={[
            { text: t("label.pending") },
            { text: t("label.completed") },
          ]}
        />
        <ScrollContainer overflowY="auto">
          <PrecallList list={list} showCompleted={showCompleted} />
        </ScrollContainer>
      </WidgetContainer>
    </>
  );
};
